window.flolab = window.flolab || {};

/*
|====================
| Home Page
|====================
*/

flolab.page = {
	home: {
		init: () => {
			$(document).on("click", ".tabs-buttons button", (evt) => {
				let target = $(evt.currentTarget)[0];
				let triggerId = target.getAttribute('data-tabId');

				target.parentNode.querySelectorAll('button').forEach((ele) => {
					ele.classList.remove('active');
				});
				target.classList.add('active');

				target.parentNode.nextElementSibling.querySelectorAll(".tabs-content .tabs").forEach((ele) => {
					ele.classList.remove('active');
				});
				document.querySelector(`.tabs-content .tabs[data-trigger='${triggerId}']`).classList.add('active');
				var carousel = document.querySelector(`.tabs-content .tabs[data-trigger='${triggerId}']`);
				if (carousel.dataset.flickity) {
					var flkty = new Flickity( carousel );
					Flickity.data(carousel)
					flkty.resize();
				}
			});

			$(document).on("click", "button.play-btn", function (evt) {
				let url = evt.currentTarget.getAttribute('data-video');
                let controller = '';
                if ($(this).attr('data-show-controller') == 'true') {
                  controller = 'controls';
                }
				let video_html = `
				<div class="popup-index" id="videoPopup">
					<div class="popup-body"> 
						<span id="closePop">&times;</span>
						<video width="100%" height="100%" ${controller} autoplay muted loop playsinline> <source src="${url}" type="video/mp4"></video>
					</div>
				</div>`;

				setTimeout(() => {
					// $('.image-element__wrap.img-video-wrap').append(video_html);
					$(this).parent().append(video_html);
					$(this).siblings(".popup-index").addClass("open");
					$(this).closest(".featured-link--wrap")?.addClass("active");
				}, 250);
			});

			$(document).on("click", "#closePop", function (evt) {
				let target = evt.currentTarget
				target.parentElement.parentElement.classList.remove("open");
				target.parentElement.parentElement.parentElement.classList.remove("active");
				setTimeout(() => {
					target.parentElement.parentElement.remove()
				}, 250);
			});

			$(document).on('change', '.options_wrapper select', function (e) {
				var trigger = e.currentTarget;
				if (trigger.classList.contains('brand-list')) {
					let triggerVal = $(this).val();
                    let selectedHtml = $(`#product_lists option[data-brand=${triggerVal}]`);
                    $('.products-list option').remove();
                    $('.products-list').append(selectedHtml).first().attr('selected', 'selected');
				} else if (trigger.classList.contains('products-list')) {
					var url = $(this).val();
					window.location.href = url;
				}
			});		
		}
	},
	product: {
		variantChange: () => {
			/* When Change Option 1 */
			$(".variant_picker .product-form_input[data-index='option-1'] .variant-option").click(function (evt) {
				let target = $(evt.currentTarget);
				target.parent().siblings().find("input").removeAttr("checked");
				target.prop("checked", true);
				let option1 = target.val() || target.data('value');
				if (target.parents(".nav-content-wrapper").hasClass("custom-option")) {
					$(".nav-content-wrapper.custom-option .nav-head input").val(`${option1}`);
					let opt1 = $(".nav-content-wrapper.custom-option .opt-name").data("name");
					// $(".nav-content-wrapper.custom-option span.opt-name").html(`${opt1}: ${option1}`);
					$(".nav-content-wrapper.custom-option span.opt-name").html(`${option1}`);
				}

				/* Get second options value in array */
				let secOptions = [];
				$(`#master-options option[data-option1='${option1}']`).map(function (ind, ele) {
					if ($.inArray($(ele).data("option2"), secOptions) == -1 && $(ele).data("option2") != "") {
						secOptions.push($(ele).data("option2"));
					}
				});

				/* Check Availibility of second Options */
				$(".variant_picker .product-form_input[data-index='option-2'] .variant-option").each(function (ind, ele) {
					if (secOptions.indexOf($(ele).val()) > -1) {
						$(ele).removeAttr("disabled");
						$(ele).removeClass("disabled");
					} else {
						$(ele).attr("disabled", true);
						$(ele).addClass("disabled");
						$($(".variant_picker .product-form_input[data-index='option-2'] .variant-option:not(:disabled)")[0]).prop("checked", true);
					}
				});

				/* Get Third options value in array */
				let option2 = $(".variant_picker .product-form_input[data-index='option-2'] input.variant-option:checked").val() || null;
				let thirdOptions = [];
				$(`#master-options option[data-option1='${option1}'][data-option2='${option2}']`).map(function (ind, ele) {
					if ($.inArray($(ele).data("option3"), thirdOptions) == -1 && $(ele).data("option3") != "") {
						thirdOptions.push($(ele).data("option3"));
					}
				});
				/* Check Availibility of second Options */
				if (thirdOptions.length > 0) {
					$(".variant_picker .product-form_input[data-index='option-3'] .variant-option").each(function (ind, ele) {
						if (thirdOptions.indexOf($(ele).val()) > -1) {
							$(ele).removeAttr("disabled");
							$(ele).removeClass("disabled");
						} else {
							$(ele).attr("disabled", true);
							$(ele).addClass("disabled");
							// $(ele).parents("ul").find("li").first().find("input").prop("checked",true);
							$($(".variant_picker .product-form_input[data-index='option-3'] .variant-option:not(:disabled)")[0]).prop("checked", true);
						}
					});
				}
				let stringArr = [];
				$(".variant-options .product-form_input input.variant-option").each(function (ind, ele) {
					if ($(this).is(':checked') || $(this).is(':selected') || $(this).is("[checked]")) {
						stringArr.push($(this).val());
					}
				});
				let string = stringArr.join(' / ');
				flolab.page.product.masterChanges(string);
			});

			/* when change option 2 */
			$(".variant_picker .product-form_input[data-index='option-2'] .variant-option").click(function (evt) {
				let target = $(evt.currentTarget);
				target.parent().siblings().find("input").removeAttr("checked");
				target.prop("checked", true);
				let option1 = $(".variant_picker .product-form_input[data-index='option-1'] input.variant-option:checked").val() || $(".variant_picker .product-form_input[data-index='option-1'] input.variant-option").attr("value");
				if (option1 == "" || option1 == undefined) {
					option1 = $(".variant_picker .product-form_input[data-index='option-1'] li .variant-option").first().data("value");
					$(".nav-content-wrapper.custom-option .nav-head input").val(`${option1}`);
				}

				let option2 = $(".variant_picker .product-form_input[data-index='option-2'] input.variant-option:checked").val() || null;
				/* Get Third options value in array */
				let thirdOptions = [];
				$(`#master-options option[data-option1='${option1}'][data-option2='${option2}']`).map(function (ind, ele) {
					if ($.inArray($(ele).data("option3"), thirdOptions) == -1 && $(ele).data("option3") != "") {
						thirdOptions.push($(ele).data("option3"));
					}
				});

				/* Check Availibility of second Options */
				if (thirdOptions.length > 0) {
					$(".variant_picker .product-form_input[data-index='option-3'] input.variant-option").each(function (ind, ele) {
						if (thirdOptions.indexOf($(ele).val()) > -1) {
							$(ele).removeAttr("disabled");
							$(ele).removeClass("disabled");
						} else {
							$(ele).attr("disabled", true);
							$(ele).addClass("disabled");
							// $(ele).parents("ul").find("li").first().find("input").prop("checked",true);
							$($(".variant_picker .product-form_input[data-index='option-3'] .variant-option:not(:disabled)")[0]).prop("checked", true);
						}
					});
				}

				let stringArr = [];
				$(".variant-options .product-form_input input.variant-option").each(function (ind, ele) {
					if ($(this).is(':checked') || $(this).is(':selected') || $(this).is("[checked]")) {
						stringArr.push($(this).val());
					}
				});
				let string = stringArr.join(' / ');
				flolab.page.product.masterChanges(string);
			});

			/* When Change Option 3 */
			$(".variant_picker .product-form_input[data-index='option-3'] .variant-option").click(function (evt) {
				let option1 = $(".variant_picker .product-form_input[data-index='option-1'] input.variant-option:checked").val() || $(".variant_picker .product-form_input[data-index='option-1'] input.variant-option").attr("value");

				if (option1 == "" || option1 == undefined) {
					option1 = $(".variant_picker .product-form_input[data-index='option-1'] li .variant-option").first().data("value");
					$(".nav-content-wrapper.custom-option .nav-head input").val(`${option1}`);
				}

				let option2 = $(".variant_picker .product-form_input[data-index='option-2'] input.variant-option:checked").val() || null;

				let target = $(evt.currentTarget);
				target.parent().siblings().find("input").removeAttr("checked");
				target.prop("checked", true);
				let option3 = target.val();

				let string = option1 + ' / ' + option2 + ' / ' + option3;
				flolab.page.product.masterChanges(string);
			})

		},
		defaultvariantSelection: (string) => {          
			let target = $(`#master-options option[value='${string}']`);
			let option1 = target.data("option1");
			let option2 = target.data("option2");
			let option3 = target.data("option3");
            console.log("Line 216 in flolab 1", option1, option2, option3);
            
			/* Set Default Values */
			/* Defalt select first option */
			if ($(".variant_picker .variant-options").find(".custom-option").length > 0) {
				$(".nav-content-wrapper.custom-option .nav-head input").val(`${option1}`);
				let opt1 = $(".nav-content-wrapper.custom-option .opt-name").data("name");
				// $(".nav-content-wrapper.custom-option span.opt-name").html(`${option1}`);
				// $(".nav-content-wrapper.custom-option span.opt-name").html(`${opt1}: ${option1}`);
				$(".nav-content-wrapper.custom-option span.opt-name").html(`${opt1}`);
			} else {
				$(`.variant_picker .product-form_input[data-index='option-1'] .variant-option[value='${option1}']`).prop("checked", true);
			}

			/* Get second options value in array */
			let secOptions = [];
			$(`#master-options option[data-option1='${option1}']`).map(function (ind, ele) {
				if ($.inArray($(ele).data("option2"), secOptions) == -1 && $(ele).data("option2") != "") {
					secOptions.push($(ele).data("option2"));
				}
			});

			/* Check Availibility of second Options */
			$(".variant_picker .product-form_input[data-index='option-2'] .variant-option").each(function (ind, ele) {
				if (secOptions.indexOf($(ele).val()) > -1) {
					$(ele).removeAttr("disabled");
					$(ele).removeClass("disabled");
				} else {
					$(ele).attr("disabled", true);
					$(ele).addClass("disabled");
				}
			});
			$(`.variant_picker .product-form_input[data-index='option-2'] .variant-option[value='${option2}']`).prop("checked", true);

			/* Get Third options value in array */

			let thirdOptions = [];
			$(`#master-options option[data-option1='${option1}'][data-option2='${option2}']`).map(function (ind, ele) {
				if ($.inArray($(ele).data("option3"), thirdOptions) == -1 && $(ele).data("option3") != "") {
					thirdOptions.push($(ele).data("option3"));
				}
			});

			/* Check Availibility of second Options */
			if (thirdOptions.length > 0) {
				$(".variant_picker .product-form_input[data-index='option-3'] .variant-option").each(function (ind, ele) {
					if (thirdOptions.indexOf($(ele).val()) > -1) {
						$(ele).removeAttr("disabled");
						$(ele).removeClass("disabled");
					} else {
						$(ele).attr("disabled", true);
						$(ele).addClass("disabled");
					}
				});
				$(`.variant_picker .product-form_input[data-index='option-3'] .variant-option[value='${option3}']`).prop("checked", true);
			}

			let stringArr = [];
			if ($(".variant-options .product-form_input input.variant-option").length > 0) {
				$(".variant-options .product-form_input input.variant-option").each(function (ind, ele) {
					if ($(this).is(':checked') || $(this).is(':selected') || $(this).is("[checked]")) {
						stringArr.push($(this).val());
					}
				});
			} else {
				stringArr.push('Default Title')
			}
			let newstring = stringArr.join(' / ');
			flolab.page.product.masterChanges(newstring);
		},
		imageChange: (string) => {
			let image = $(`#master-options option[value='${string}']`).data("image");
            let imageEle = $('.product_gallery_nav.product-gallery__thumbnails').find(`img[src='${image}']`);
            let imageElement = imageEle.parent().index(); // Access the underlying DOM element
                imageElement = Number(imageElement);
            let $sourceDiv = $('.product_gallery').find('.flickity-slider').children(`[data-index="`+imageElement+`"]`);
            let $destinationDiv =  $('.product_gallery').find('.flickity-slider').children('.is-selected');

            if($sourceDiv.length && $destinationDiv.length){
            let $sourceDivHtml = $sourceDiv.html();
            var $sourceDivAttributes = {};
            
            let $destinationDivHtml = $destinationDiv.html();
            var $destinationDivAttributes = {};
            $destinationDiv.removeClass('is-selected');
            // $sourceDiv.addClass('is-selected');
            $.each($sourceDiv[0].attributes, function(index, attribute) {
              $sourceDivAttributes[attribute.name] = attribute.value;
            });
          
            $.each($destinationDiv[0].attributes, function(index, attribute) {
              $destinationDivAttributes[attribute.name] = attribute.value;
            });
          
            $.each($destinationDivAttributes, function(name, value) {
              $sourceDiv.attr(name, value);
            });
      
            $.each($sourceDivAttributes, function(name, value) {
              $destinationDiv.attr(name, value);
            });
            $sourceDiv.html($destinationDivHtml);
            $destinationDiv.html($sourceDivHtml);
            console.log($sourceDivAttributes,"\n",$destinationDivAttributes);
            }else{
    			$(`.product_gallery_nav.product-gallery__thumbnails .flickity-slider img[src='${image}']`).parent().trigger('click');
            }
		},
		priceChange: (string) => {
			let price = $(`#master-options option[value='${string}']`).data("price");
			let compare_price = $(`#master-options option[value='${string}']`).data("compare");
			if (parseFloat(compare_price) > parseFloat(price)) {
				/* main Price */
				$(".prices_wrapper .price .money").html(window.Shopify.formatMoney(parseFloat(price), $('body').data('money-format')));

				/* remove compare price value */
				$(".prices_wrapper .compare-price .money").html(window.Shopify.formatMoney(parseFloat(compare_price), $('body').data('money-format')));;
				$(".prices_wrapper").addClass('on-sale');
			} else {
				/* main Price */
				$(".prices_wrapper .price .money").html(window.Shopify.formatMoney(parseFloat(price), $('body').data('money-format')));

				/* remove compare price value */
				$(".prices_wrapper .compare-price .money").html('');
				$(".prices_wrapper").removeClass('on-sale');
			}
		},
		urlChange: (string) => {
			let varId = $(`#master-options option[value='${string}']`).data("varid");
			/* Change var id of main product */
			$(".product-block.product-block--form form input[name='id']").val(varId);

			let url = new URLSearchParams(window.location.search);
			if (url.has('variant')) {
				url.set('variant', varId);
			} else {
				url.append('variant', varId);
			}

			var newurl =
				window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname +
				'?' + url.toString();
			window.history.replaceState({ path: newurl }, '', newurl);
		},
		checkAvailibility: (string) => {
			let availibility = $(`#master-options option[value='${string}']`).data("availibility");
			if (availibility || availibility == "true") {
				$(".add_to_cart.product-btn span.text").text("Add to Cart");
				$(".add_to_cart.product-btn").removeClass("disabled");
				$(".add_to_cart.product-btn").removeAttr("disabled");
			} else {
				$(".add_to_cart.product-btn span.text").text("Sold Out");
				$(".add_to_cart.product-btn").addClass("disabled");
				$(".add_to_cart.product-btn").attr("disabled", true);
			}
		},
		masterChanges: (targetedString) => {
			flolab.page.product.imageChange(targetedString);
			flolab.page.product.priceChange(targetedString);
			flolab.page.product.urlChange(targetedString);
			flolab.page.product.checkAvailibility(targetedString);
		},

		init: () => {
			let url = new URLSearchParams(window.location.search),
			string;
         
            let modelName = "getCurrentModelName()";
            console.log(modelName, "modelName", url.has('variant'));
          
			if (url.has('variant')) {
				let variant = url.get('variant');
              console.log(variant, "variants name")
				string = $(`#master-options option[data-varid='${variant}']`).val();
			}
            else if(modelName){
              let isUpdated= false;
              $('#master-options option').each(function(index){
                let optVal = $(this).data('handlize-title');
                console.log(modelName, optVal, "option");
                
                if(optVal === modelName){
                  string = document.querySelector('#master-options [data-handlize-title="'+optVal+'"]').value;
                  isUpdated = true;
                }
                // else if(!isNaN(optVal)){
                //   string = document.querySelector('#master-options [data-handlize-title="'+optVal+'"]').value;
                //   isUpdated = true;
                // }
                // else if(!isNaN(modelName)){
                //   string = document.querySelector('#master-options [data-handlize-title="'+modelName+'"]').value;
                //   isUpdated = true;
                // }
                if(!isUpdated){
                  let getCurrentVarint = $(".navbar-nav").find(".nav-title[checked]").attr('data-variantId');
                  string = $(`#master-options option[data-varid='${getCurrentVarint}']`).val();
                }
                // console.log(optVal, modelName, "optVal");
              });
            }
            else{
				let getCurrentVarint = $(".navbar-nav").find(".nav-title[checked]").attr('data-variantId');
				string = $(`#master-options option[data-varid='${getCurrentVarint}']`).val();
              // if (getCurrentVarint) {
              //   window.history.replaceState({}, document.title, `${window.location.pathname}?variant=${getCurrentVarint}`);
              // }     
            
            }
			
          
			setTimeout(() => {
				// flolab.page.product.defaultvariantSelection("15 Plus");
                flolab.page.product.defaultvariantSelection(string);
              console.log(string, "final string");
				const defaultVarCheck = document.querySelector('#master-options').value;
				if (defaultVarCheck != 'Default Title') {
					const atcBtn = document.querySelector('.shopify-product-form .btns-wrapper .add_to_cart');
					atcBtn.setAttribute('disabled','disabled');
					atcBtn.classList.add('disabled');
				}
			}, 150);

			/* Check image-with-text object */
			let objects = window.metaValue;
			if (objects) {
				let html = '';
				for (const object in objects) {
					let obj = objects[object];
					if (obj.image_position == 'left') {
						var className = 'is-flex-row';
					} else {
						var className = 'is-flex-row-reverse'
					}
					/* Video Play Button */
					if (obj.video.length != 0) {
						if (obj.autoplay == 1) {
							var video = `<div class="popup-index open" id="videoPopup">
                                <div class="popup-body">
                                    <video width="100%" height="100%" controls autoplay muted loop playsinline> <source src="${obj.video}" type="video/mp4"></video>
                                </div>
                            </div>`
						} else {
							var btn = `<button class="play-btn" data-video="${obj.video}"><svg xmlns="http://www.w3.org/2000/svg" width="121" height="121" viewBox="0 0 121 121" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M60.5 121C93.9132 121 121 93.9132 121 60.5C121 27.0868 93.9132 0 60.5 0C27.0868 0 0 27.0868 0 60.5C0 93.9132 27.0868 121 60.5 121ZM51.25 76.5215L79 60.5L51.25 44.4785V76.5215Z" fill="white"></path></svg></button>`
							var video = `<img src="${obj.image}" alt="image-with-text" class="transition--blur-up lazyautosizes lazyloaded" height="699" width="960" />
                            ${btn}`
						}
					} else {
						var video = `<img src="${obj.image}" alt="image-with-text" class="transition--blur-up lazyautosizes lazyloaded" height="699" width="960" />`;
					}
					/* Button 1 */
					if (obj.button_label_1 != "") {
						var btn1 = `<a href="${obj.link_1}">${obj.button_label_1}</a>`;
					} else {
						var btn1 = '';
					}
					/* Button 2 */
					if (obj.button_label_2 != "") {
						var btn2 = `<a href="${obj.link_2}">${obj.button_label_2}</a>`;
					} else {
						var btn2 = '';
					}
					/* Button 3 */
					if (obj.button_label_3 != "") {
						var btn3 = `<a href="${obj.link_3}">${obj.button_label_3}</a>`;
					} else {
						var btn3 = '';
					}
					/* Button 4 */
					if (obj.button_label_4 != "") {
						var btn4 = `<a href="${obj.link_4}">${obj.button_label_4}</a>`;
					} else {
						var btn4 = '';
					}

					html += `
					<div class="image-with-text-container featured_collections ${className} flex-row-reverse">
						<div class="featured-link--half one-half column image-with-text__image-column is-align-center image-with-text__column medium-down--one-whole image-crop--none">
							<div class="featured-link--wrap active">
								<div class="image-element__wrap">
									${video}
								</div>
							</div>
						</div>
						<div class="featured-link--half one-half column image-with-text__text-column is-flex is-align-center image-with-text__column medium-down--one-whole">
							<div class="info text-align--left">
								<a href="" class="collection_title h2 heading">${obj.title}</a>
								<div class="rte">
									${obj.text}
								</div>
								<div class="actions-wrapper">
									${btn1}
									${btn2}
									${btn3}
									${btn4}
								</div>
							</div>
						</div>
					</div>`;
				}

				$(".section.image-text-section .container .meta-data-text").html(html);
			}

			/* Check Meta information Obj */

			let metaobjects = window.metainfo
			if (metaobjects) {
				let html = '';
				for (const object in metaobjects) {
					let obj = metaobjects[object];
					html += `
						<div class="content--wrapper">
  						<h3 class="heading h3">${obj.title}</h3>
  						<div class="rte"><p>${obj.content}</p></div>
						</div>`;
				}
				$(".text_content").html(html);
			}
		},
		tabInit: () => {
			let btns = '';
			$("[name='target-section']").each(function () {
				let targetId = $(this).attr("data-id") || $(this).attr("id");
				let btn = $(this).attr("data-btn");
				if (btns.search(btn) == -1) {
					btns += `
						<li><a href='#${targetId}' class='target-link'>${btn}</a></li>
					`;
					$(this).parent(['data-section-init']).attr("id", targetId);
				}
			});
			btns += `<li><a href="#secID-review-widget" class="target-link">reviews</a></li>`;

			let html = `<div class='target-tabs-section'><ul class="container">${btns}</ul></div>`;
			$(".target-sec-below").after(html);

			$(".target-tabs-section ul>li a").click(function () {
				$(this).parent().siblings().removeClass('active');
				$(this).parent().addClass('active');
			});
		}
	},
	swiper: {
		initSlider: () => {
			new Swiper(".slider-gallery.products-slider", {
				slidesPerView: 2,
				spaceBetween: 20,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					992: {
						slidesPerView: 3
					},
					1199: {
						slidesPerView: 4
					}
				}
			})
		}
	}
};

let getCurrentModelName = () => {
  let url = window.location.href;
      
  if(url.includes('/collections')){
    let arr = url.split('/');
    let collectionName = arr[4];
    let finalString = null;

    let masterOptions = document.querySelectorAll('#master-options option');

    masterOptions.forEach((option, index) => {
      let optionValue = option.getAttribute("data-handlize-title");
      var regEx = new RegExp(optionValue, 'g');
      let proOrMax = optionValue.includes('pro') || optionValue.includes('plus') ? true : false;
      let collectionNameArray = collectionName.split("-");
      let collectionNameFiltered=[];
      collectionNameArray.forEach((optVal, index)=>{
        if(!isNaN(optVal)){
          if(collectionNameArray[index-1]){
            collectionNameFiltered[0]=collectionNameArray[index-1];
          }
          collectionNameFiltered[1]=collectionNameArray[index];
          if(collectionNameArray[index+1] && ["pro", "plus"].includes(collectionNameArray[index+1])){
            collectionNameFiltered[2]=collectionNameArray[index+1]; 
          }
          if(collectionNameArray[index+2] === "max"){
            collectionNameFiltered[3]=collectionNameArray[index+2]; 
          }
        }
      });
      // console.log(collectionNameArray, collectionNameFiltered, "collectionNameFiltered", optionValue, collectionNameFiltered.join("-"), collectionNameFiltered.join("-").replace("iphone-", ""));
      if(collectionNameFiltered.join("-") === optionValue || collectionNameFiltered.join("-").replace("iphone-", "") === optionValue){
          finalString = optionValue;
          // console.log(collectionName.match(regEx), "search str", optionValue, collectionName, proOrMax);
      }
      // else if(!isNaN(optionValue)){
      //   finalString = optionValue;
      // }
    });
    return finalString;
  }
  else{
    return null;
  }
}
flolab.footer = function () {
	if (window.innerWidth <= 798) {
		$('.site-footer .logo-img').prependTo('.footer-blocks');
		$('.site-footer .menu-title').click(function () {
			$(this).toggleClass('active').siblings('.main-links').toggleClass('active');
		})
	} else if (window.innerWidth <= 1280) {
		$('.site-footer .payment-icons,.copy-right').appendTo('.footer-blocks');
	}
};
flolab.lifeStyleGallery = function () {
	if (document.querySelector(".pdp-life-style-gallery-wrapper")) {
		const slider = new Swiper(".pdp-life-style-gallery-wrapper", {
			slidesPerView: "1.3",
			spaceBetween: 20,
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				798: {
					slidesPerView: 2.3,
					centeredSlides: true
				}
			}
		});
		slider.slideTo(1, 600)
	}
}
flolab.collection = function () {
	$('#plpSidebarTrigger').click(function () {
		$('.plp-content-wrapper').toggleClass('active');
		if (window.innerWidth <= 991) {
			$('.sidebar').slideToggle();
		} else {
			$('.sidebar').animate({ width: 'toggle' });
		}
	});

	$(document).on('click', '#mbPlpPagination', function () {
		let nextUrl = $(this).attr('data-next-page'),
			that = $(this);
		$(this).text('loading..');
		$.ajax({
			method: 'GET',
			url: nextUrl,
			dataType: 'html',
			success: function (data) {
				let products = $(data).find('.main-collection .product-list').html();
				let nextUrl = $(data).find('#mbPlpPagination').attr('data-next-page');
				$('#mbPlpPagination').attr('data-next-page', nextUrl);
				$('.main-collection .product-list').append(products);
				$(that).text('See More');
			}
		})
	})
}
flolab.header = function () {
	$('#mobile_menu a .icon-down-arrow').click(function () {
		$(this).parents('[data-mobile-dropdown-rel]').siblings().hide();
		$(this).siblings('.icon-back').show();
	});
	$('#mobile_menu a .icon-back').click(function (e) {
		e.preventDefault();
		$(this).hide();
		$(this).parents('[data-mobile-dropdown-rel]').siblings().show();
		$(this).siblings('.right').removeClass('active');
	});

	let interIdObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				document.querySelector('body').classList.add('menu-open');
			} else {
				document.querySelector('body').classList.remove('menu-open');
			}
		})
	});

	let tergetInter = document.querySelectorAll(".main-nav__wrapper .dropdown_container");
	tergetInter.forEach(io => {
		interIdObserver.observe(io)
	});
}
flolab.compare_page = function ($triggerEle) {
	let cacheHeight = 0;
	$($triggerEle).each(function () {
		let eleHeight = $(this).height();
		(eleHeight > cacheHeight) ? cacheHeight = eleHeight : cacheHeight = cacheHeight;
	})
	$($triggerEle).height(cacheHeight);
}
flolab.tabsection = function () {
	let btns = document.querySelectorAll('.btn-data');
	btns.forEach((btnn) => {
		btnn.addEventListener("click", (btnt) => {
			let btn = btnt.currentTarget;
			let buttonTarget = btn.getAttribute('data-btntarget');
			document.querySelectorAll('.tab-btn').forEach((btnDiv) => {
				btnDiv.classList.remove('active');
			});
			btn.closest('.tab-btn').classList.add('active');

			let btnDatas = document.querySelectorAll('.compare-products .dm-tr');
			btnDatas.forEach((btnData) => {
				btnData.classList.remove('active');
				let DataTarget = btnData.getAttribute('data-target');
				if (buttonTarget == DataTarget) {
					btnData.classList.add('active');
				}
			})
		})
	})
}
flolab.loadtabsection = function () {
	const btndata = document.querySelectorAll('.btn-data');
	btndata.forEach((btnn) => {
		if (btnn.parentElement.classList.contains('active')) {
			let buttonTarget = btnn.getAttribute('data-btntarget');
			let btnDatas = document.querySelectorAll('.compare-products .dm-tr');
			btnDatas.forEach((btnData) => {
				let DataTarget = btnData.getAttribute('data-target');
				if (buttonTarget == DataTarget) {
					btnData.classList.add('active');
				}
			})
		}
	})
}

flolab.pdpactivetab = function () {
	var topMenu = $(".target-tabs-section"),
		topMenuHeight = topMenu.outerHeight() + 70;
	menuItems = topMenu.find("a"),
		scrollItems = menuItems.map(function () {
			var item = $($(this).attr("href"));
			if (item.length) { return item; }
		});

	$(window).scroll(function () {
		var fromTop = $(this).scrollTop() + topMenuHeight + 20;

		var cur = scrollItems.map(function () {
			if ($(this).offset().top < fromTop)
				return this;
		});
		cur = cur[cur.length - 1];
		var id = cur && cur.length ? cur[0].id : "";
		menuItems
			.parent().removeClass("active")
			.end().filter("[href='#" + id + "']").parent().addClass("active");
	});
}


$(document).ready(function () {
	$('.read-more').click(function (e) {
		e.preventDefault();
		var lessDesc = $(this).siblings('.less-desc'),
			fllDesc = $(this).siblings('.full-desc');
		if ($(this).text() == 'Read More') {
			lessDesc.hide();
			fllDesc.show();
			$(this).text('Read Less');
		} else {
			lessDesc.show();
			fllDesc.hide();
			$(this).text('Read More');
		}
		// $('.desc-wrap').toggleClass('active');
		// if ($('.desc-wrap').hasClass('active')) {
		//     $(this).siblings('.full-desc').show();
		//     $(this).siblings('.less-desc').hide();
		//     $('.read').html("Read Less");
		// } else {
		//     $('.read').html("Read More");
		//     $(this).siblings('.full-desc').hide();
		//     $(this).siblings('.less-desc').show();
		// }
	});

	let headerHeight = 0;
	if (window.innerWidth <= 992) {
		headerHeight = document.querySelector('#header').clientHeight;
	} else {
		headerHeight = document.querySelector('#shopify-section-header').clientHeight;
	}
	document.querySelector('html').style.setProperty('--header-height', `${headerHeight}px`);

	flolab.page.home.init()

	flolab.footer();
	flolab.header();
	flolab.tabsection();
	flolab.loadtabsection();
	if (__st.p == 'product') {
		flolab.page.product.init();
		flolab.lifeStyleGallery();
		flolab.page.product.tabInit();
		flolab.page.product.variantChange();
		flolab.pdpactivetab();
	}
	flolab.collection();
	flolab.compare_page('.nav-comparemodel-wrapper .prod-img-title');
	flolab.compare_page('.nav-comparemodel-wrapper .description');
	flolab.compare_page('.nav-comparemodel-wrapper .size_thickness');
	flolab.compare_page('.nav-comparemodel-wrapper .material');
	flolab.compare_page('.nav-comparemodel-wrapper .case-friendly');
	flolab.compare_page('.nav-comparemodel-wrapper .clarity');
	flolab.compare_page('.nav-comparemodel-wrapper .impact-protection');
	flolab.compare_page('.nav-comparemodel-wrapper .durability');
	flolab.compare_page('.nav-comparemodel-wrapper .installation-kit');
	flolab.compare_page('.nav-comparemodel-wrapper .ease-of-installation');
	flolab.compare_page('.nav-comparemodel-wrapper .lifetime-warranty');
	flolab.compare_page('.nav-comparemodel-wrapper .antimicrobial');
	flolab.compare_page('.nav-comparemodel-wrapper .oleophobic');
	flolab.compare_page('.nav-comparemodel-wrapper .touch-id-face-id');
	flolab.compare_page('.nav-comparemodel-wrapper .compatible-cases');
});

$('body').on('change','.product-variant-wrapper',function(){
  let linkTag = $(this).parents('.content-wrapper').children('a');
  let id = $(this).children(':selected').attr('data-id');
  let image = $(this).children(':selected').attr('data-image');
  let price = $(this).children(':selected').attr('data-price');
  let cprice = $(this).children(':selected').attr('data-cprice');
  if(price){
    $(this).parents('.content-wrapper').find('.product-price').children('.money').text(price);
    $(this).parents('.content-wrapper').find('.was_price').children('.money').text(cprice);
  }
  let href = linkTag.attr('href');
  href = href.split('?')[0];
  href = href + `?variant=${id}`;
  linkTag.prop('href',href);
  $(this).parents('.content-wrapper').siblings('.product-wrap').find('a').prop('href',href);
  if( image ){
  $(this).parents('.content-wrapper').siblings('.product-wrap').find('.image__container').find('img').prop('srcset',image)
  $(this).parents('.content-wrapper').siblings('.product-wrap').find('.image__container').find('img').prop('src',image)
  $(this).parents('.content-wrapper').siblings('.product-wrap').find('.image__container').find('img').prop('data-src',image)
  }
})
